import EmberDataBaseAdapter from '@square/dashboard-data/adapters/ember-data-base-adapter';
import multipartFormSerialize from '@square/dashboard-data/utils/multipart-form-serialize';
import { ajax, jsonDelete } from '@square/dashboard-utilities/utils/xhr';
import { isNone } from '@ember/utils';
export default EmberDataBaseAdapter.extend({
  buildURL() {
    return '/api/v1/merchant-profile/images';
  },
  shouldSaveViaFormData(record) {
    return 'file' in record.changedAttributes() && !isNone(record.file);
  },
  updateRecord(store, type, snapshot) {
    const record = snapshot.record;
    if (this.shouldSaveViaFormData(record)) {
      return this._submitRecordViaFormData(record, 'PUT');
    } else {
      return this._super(store, type, snapshot);
    }
  },
  createRecord(store, type, snapshot) {
    const record = snapshot.record;
    if (this.shouldSaveViaFormData(record)) {
      return this._submitRecordViaFormData(record, 'POST');
    } else {
      return this._super(store, type, snapshot);
    }
  },
  deleteRecord(store, type, snapshot) {
    const url = this.buildURL();
    return jsonDelete(url, snapshot.record.serialize());
  },
  _submitRecordViaFormData(record, method) {
    const params = {
      type: method,
      data: this.toFormData(record),
      processData: false,
      contentType: false
    };
    const url = this.buildURL(record.constructor, record.token);
    return ajax(url, params);
  },
  toFormData(record) {
    const fd = new FormData();
    const payload = record.serialize();
    multipartFormSerialize(payload, [], [], true, []).forEach(([key, value]) => fd.append(key, value));
    return fd;
  }
});